export default "__VITE_ASSET__9195ee16__"